import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from 'src/app/core/alert.service';
import { ToastService } from 'src/app/core/toast.service';
import { ApiCepService } from 'src/app/dao/api-cep.service';
import { GlobalService } from 'src/app/dao/global.service';
import { Cep } from 'src/app/model/cep';

@Component({
  selector: 'app-cep-list-ativo',
  templateUrl: './cep-list-ativo.page.html',
  styleUrls: ['./cep-list-ativo.page.scss'],
})
export class CepListAtivoPage implements OnInit {

  showSearch: boolean = false;
  ceps: Cep[] = [];
  cep: Cep;
  inicio = '';
  fim = '';
  user: string;
  pass: string;
  idCategoria;


  constructor(private route: ActivatedRoute,
    private toast: ToastService,
    private alert: AlertService,
    private apicep: ApiCepService,
    private global: GlobalService) { }



  ngOnInit() {
    this.user = this.global.user;
    this.pass = this.global.pass;
    this.loadProd();
    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
      // tslint:disable-next-line: radix
      this.idCategoria = parseInt(idParam);
      // tslint:disable-next-line: radix
    }
  }

  ionViewWillEnter() {
    this.user = this.global.user;
    this.pass = this.global.pass;
    this.loadProd();
  }

  async loadProd() {
    this.apicep.listarTodas().then(res => {
      console.log('res', res);
      this.ceps = res;
      //this.toast.showSucess('Ceps obtidos com sucesso!');
    }).catch(async err => {
      console.log('err', err);
      this.toast.showError('Erro ao obter Ceps');
    });
  }
  searchButtonClick() {
    this.showSearch = true;
  }

  doSearchBarCancel() {
    this.showSearch = false;
    this.loadProd();
  }

  async doSearchBarChange($event: any) {
    let value = $event.target.value;
    // if (value && value.lenght >= 2) {
    value = value.replace(/\s+/g, "_");
    this.ceps = await this.apicep.GetByNome(value);

    // }
  }



  delete(cep: Cep) {
    this.alert.showConfirmDelete(cep.descritivo, () => this.executeDelete(cep));
  }

  private async executeDelete(cep: Cep) {
    try {
      await this.apicep.excluir(cep.id);
      const index = this.ceps.indexOf(cep);
      this.ceps.splice(index, 1);
      this.toast.showSucess('Cep excluído com sucesso!');
    } catch (error) {
      this.toast.showError('Ocorreu um erro ao tentar excluir o Cep!');
    }

  }

  mudastts(cep: Cep) {
    const novoStatus = !cep.ativo;
    cep.ativo = novoStatus;
    this.apicep.atualizar(cep)
      .then(() => {
        const acao = novoStatus ? 'ativado' : 'desativado';
        cep.ativo = novoStatus;
        //this.toast.showSucess(`Cep ${acao} com sucesso!`);
      })
      .catch(erro => {
        console.log(erro);
        this.toast.showError('Erro ao Alterar Status');
      });

  }

}
